import type { FC } from 'react'

import { CarouselLoading, unit } from '@hcr/ui'

export const HoldingsLoading: FC = () => {
  return <CarouselLoading slidesMargin={unit(3)} />
}
